import FormControl from '@/ui-kit/components/form/entities/FormControl';
import { emailFormValidator, phoneFormValidator, requiredFormValidator } from '@/ui-kit/components/form/validators';
import HowItWorksBuilderControlName from '../enums/HowItWorksBuilderEnums';
import FormGroup from '@/ui-kit/components/form/entities/FormGroup';

export type HowItWorksForm = {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  // TODO: replace with string[]
  locations: string;
  phone: string;
};

const createHowItWorksBuilderFormGroup = (): FormGroup<HowItWorksForm> => {
  const firstNameControl = new FormControl(
    '',
    [requiredFormValidator],
  );
  const lastNameControl = new FormControl(
    '',
    [requiredFormValidator],
  );
  const emailControl = new FormControl(
    '',
    [requiredFormValidator, emailFormValidator],
  );
  const companyNameControl = new FormControl(
    '',
    [requiredFormValidator],
  );
  const locationsControl = new FormControl(
    '',
    [requiredFormValidator],
  );
  const phoneControl = new FormControl(
    '',
    [phoneFormValidator],
  );

  return new FormGroup({
    [HowItWorksBuilderControlName.FirstName]: firstNameControl,
    [HowItWorksBuilderControlName.LastName]: lastNameControl,
    [HowItWorksBuilderControlName.Email]: emailControl,
    [HowItWorksBuilderControlName.CompanyName]: companyNameControl,
    [HowItWorksBuilderControlName.Locations]: locationsControl,
    [HowItWorksBuilderControlName.Phone]: phoneControl,
  });
};

export default createHowItWorksBuilderFormGroup;
